import moment from 'moment';
import get from 'lodash/get';

const f = 'MM-DD-YYYY';
export default function inDays(gluValue, { days = [], nin = [] }) {
  const value = get(gluValue, 'startDate') || get(gluValue, 'endDate') || gluValue;
  const day = moment(Array.isArray(value) ? value[0] : value).format(f);
  const formattedDays = days.map((date) => moment(date).format(f));
  const notIn = nin.map((date) => moment(date).format(f));

  if (formattedDays.length && !formattedDays.includes(day)) {
    return 'Selected day is not allowed';
  }

  if (notIn.includes(day)) {
    return 'Selected day is not allowed';
  }

  return null;
}
